import { createRoot } from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';
import App from "./App.tsx";
import "./index.css";
import { initializeSecurity } from "./utils/securityEnforcement";
import { initializePerformanceMonitoring } from "./utils/performanceOptimizer";

// Initialize security and performance monitoring
const cleanupSecurity = initializeSecurity();
const cleanupPerformance = initializePerformanceMonitoring();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

// Cleanup on page unload
window.addEventListener('beforeunload', () => {
  cleanupSecurity();
  cleanupPerformance();
});
